import React from "react";
import { Form } from "react-bootstrap";
import { useArsTable } from "./ArsTableContextProvider";
import { ARST_SET_SIDEBAR_VIEW } from "./interface";

/**
 * ArsTableSidebarViewRadio provides radio button controls to switch between
 * grouping factors and operations views. The operations view is disabled when
 * no analysis method is selected.
 *
 * @returns Radio button group element, or null when there is no table context
 */
export const ArsTableSidebarViewRadio = (): React.ReactNode => {
  const { state, dispatch } = useArsTable();

  const currentView = state?.settings.currentSidebar.view ?? "groupingFactor";
  const hasAnalysisMethod = (state?.bodyData.analysisMethodId ?? "") !== "";

  return !state ? null : (
    <div className="d-flex gap-3">
      <Form.Check
        type="radio"
        id="ars-table-sidebar-view-grouping-factors"
        label="Grouping factors"
        name="ars-table-sidebar-view"
        value="groupingFactor"
        checked={currentView === "groupingFactor"}
        disabled={state.settings.disabled}
        onChange={() => {
          dispatch({
            operation: ARST_SET_SIDEBAR_VIEW,
            view: "groupingFactor",
          });
        }}
      />
      <Form.Check
        type="radio"
        id="ars-table-sidebar-view-operations"
        label="Operations"
        name="ars-table-sidebar-view"
        value="operations"
        checked={currentView === "operations"}
        disabled={!hasAnalysisMethod || state.settings.disabled}
        onChange={() => {
          dispatch({
            operation: ARST_SET_SIDEBAR_VIEW,
            view: "operations",
          });
        }}
      />
    </div>
  );
};

ArsTableSidebarViewRadio.displayName = "ArsTableSidebarViewRadio";
